import React from "react";
import { Box, IconButton, useMediaQuery, useTheme } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import {
  setIsDrawingStarted,
  setStartImageProcessing,
  setTimer,
  setTimerDone,
} from "../../../state/actions";
import { connect } from "react-redux";
import { colors } from "../../../constants/site-content";
const totalWidth = "108px"; // retained but no longer used for positioning

interface CanvasSubmitControllerToolbarProps {
  resetCanvas: () => void;
}

const CanvasSubmitControllerToolbar = ({
  resetCanvas,
  ...props
}: any & CanvasSubmitControllerToolbarProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isPortrait = useMediaQuery("(orientation: portrait)");

  const handleEarlySubmitClick = () => {
    props.setStartImageProcessing(true);
  };

  const handleAbortDrawingClick = () => {
    props.setTimer({
      showTimer: false,
    });
    props.setTimerDone(true);
    props.setIsDrawingStarted(false);
    resetCanvas();
  };

  return (
    <Box
      id="canvas-submit-controller-toolbar"
      sx={{
        position: "absolute",
        bottom: isMobile? "auto": 10,
        top: isMobile ? `calc(50% + 16px)` : "auto",
        // Stick to the inner edge of the canvas relative to the splitter:
        // - If canvas is on the right (leftHand=false), place 16px from canvas' left edge
        // - If canvas is on the left (leftHand=true), place 16px from canvas' right edge
        left: isPortrait ? "50%" : (props.leftHand ? "auto" : "16px"),
        right: isPortrait ? "auto" : (props.leftHand ? "16px" : "auto"),
        display: "flex",
        alignItems: "center",
        transform: isPortrait ? "translateX(-50%)" : "none",
        zIndex: 1000,
      }}
    >
      <IconButton
        onClick={handleAbortDrawingClick}
        sx={{
          width: isMobile ? 35 : 50,
          height: isMobile ? 35 : 50,
          backgroundColor: "transparent",
          border: `1px solid ${colors.colorNeutral900}`,
          mr: 1,
          "&:hover": {
            backgroundColor: "transparent",
          },
        }}
      >
        <CloseIcon sx={{ color: colors.colorNeutral400 }} />
      </IconButton>

      <IconButton
        onClick={handleEarlySubmitClick}
        sx={{
          width: isMobile ? 35 : 50,
          height: isMobile ? 35 : 50,
          backgroundColor: colors.colorNeutral900,
          color: "white",
          "&:hover": {
            backgroundColor: colors.colorNeutral900,
          },
        }}
      >
        <CheckIcon sx={{ color: "white" }} />
      </IconButton>
    </Box>
  );
};

const mapStateToProps = (state) => {
  const { leftHand } = state;
  return { leftHand };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setTimerDone: (payload) => dispatch(setTimerDone(payload)),
    setStartImageProcessing: (payload) =>
      dispatch(setStartImageProcessing(payload)),
    setIsDrawingStarted: (payload: any) =>
      dispatch(setIsDrawingStarted(payload)),
    setTimer: (payload: any) => dispatch(setTimer(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CanvasSubmitControllerToolbar);
